export default "__VITE_ASSET__38bf4fa6__"